var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.267A4.267 4.267 0 0 1 4.267 0H4.8a.533.533 0 1 1 0 1.067h-.533a3.2 3.2 0 0 0-3.2 3.2V4.8A.533.533 0 1 1 0 4.8v-.533zM10.667.533c0-.294.238-.533.533-.533h.533A4.267 4.267 0 0 1 16 4.267V4.8a.533.533 0 0 1-1.067 0v-.533a3.2 3.2 0 0 0-3.2-3.2H11.2a.533.533 0 0 1-.533-.534zM.533 10.667c.295 0 .534.238.534.533v.533a3.2 3.2 0 0 0 3.2 3.2H4.8A.533.533 0 0 1 4.8 16h-.533A4.267 4.267 0 0 1 0 11.733V11.2c0-.295.239-.533.533-.533zm14.934 0c.294 0 .533.238.533.533v.533A4.267 4.267 0 0 1 11.733 16H11.2a.533.533 0 1 1 0-1.067h.533a3.2 3.2 0 0 0 3.2-3.2V11.2c0-.295.24-.533.534-.533z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutline);
export default __webpack_public_path__ + "static/media/outline.0b5fc466b8e7bca889b97a2bc44df726.svg";
export { ForwardRef as ReactComponent };